<template>
  <div>
    <div class="inner">
      <div class="header">
        <div class="block-title">
          <h1>Segnalazioni</h1>
          <p>Segnala punti pericolosi e attraversamenti pedonali</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "HeaderSegnala"
};
</script>


<style lang="less" scoped>
.bg-right {
  width: 50%;
  position: absolute;
  right: 0;
  bottom: 0;
}
</style>